/* eslint-disable jsx-a11y/alt-text */
// import { t } from 'i18next';
// import { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';
// import { getAsync, postAsync } from '../helper/axiosHelper';

// function Banner() {
// const isActive = useSelector((state) => state.toggle.isActive);
// const { pathname } = useLocation();
// const [apiData, setApiData] = useState([]);
// const [currentDevice, setCurrentDevice] = useState(null); // Track the current device type
// const [pageOptions, setPageOptions] = useState({
//   page: 1,
//   pageSize: 3,
// });

// const isMobile = () => window.innerWidth < 640;
// const isTablet = () => window.innerWidth >= 640 && window.innerWidth < 1024;
// const isDesktop = () => window.innerWidth >= 1024;

// // API call functions
// const mobile = async () => {
//   await postAsync(
//     `CMS_Slider/GetActiveSliderMobile?page=${pageOptions.page}&pageSize=${pageOptions.pageSize}`,
//     {},
//   ).then((response) => {
//     console.log('Mobile API Response', response.data);
//     setApiData(response.data);
//   });
// };

// const tab = async () => {
//   await postAsync(
//     `CMS_Slider/GetActiveSliderTablet?page=${pageOptions.page}&pageSize=${pageOptions.pageSize}`,
//     {},
//   ).then((response) => {
//     console.log('Tablet API Response', response.data);
//     setApiData(response.data);
//   });
// };

// const desk = async () => {
//   await postAsync(
//     `CMS_Slider/GetActiveSliderDesktop?page=${pageOptions.page}&pageSize=${pageOptions.pageSize}`,
//     {},
//   ).then((response) => {
//     console.log('Desktop API Response', response.data);
//     setApiData(response.data);
//   });
// };

// // Check the screen size and run the appropriate function if the device type has changed
// const checkDeviceType = () => {
//   let newDevice = null;
//   if (isMobile()) {
//     newDevice = 'mobile';
//   } else if (isTablet()) {
//     newDevice = 'tablet';
//   } else if (isDesktop()) {
//     newDevice = 'desktop';
//   }

//   // Only call the API if the device type has changed
//   if (newDevice && newDevice !== currentDevice) {
//     setCurrentDevice(newDevice);
//     if (newDevice === 'mobile') {
//       mobile();
//     } else if (newDevice === 'tablet') {
//       tab();
//     } else if (newDevice === 'desktop') {
//       desk();
//     }
//   }
// };

// // to check size of window
// useEffect(() => {
//   checkDeviceType(); // Run on component mount

//   // Set up an event listener for window resizing
//   window.addEventListener('resize', checkDeviceType);

//   // Clean up the event listener on unmount
//   return () => {
//     window.removeEventListener('resize', checkDeviceType);
//   };
// }, [currentDevice]);

// const getImageSrc = (slide) => {
//   switch (currentDevice) {
//     case 'mobile':
//       return `data:image/jpeg;base64,${slide.sliderImage3}`;
//     case 'tablet':
//       return `data:image/jpeg;base64,${slide.sliderImage2}`;
//     case 'desktop':
//       return `data:image/jpeg;base64,${slide.sliderImage1}`;
//     default:
//       return `data:image/jpeg;base64,${slide.sliderImage1}`;
//   }
// };

// useEffect(() => {
//   document.body.dir = isActive ? 'rtl' : 'ltr';
// }, [isActive]);

// const [currentIndex, setCurrentIndex] = useState(0);
// const [direction] = useState(true);

// const slides = [
//   {
//     src: '/assets/images/background/banner-4.jpg',
//     alt: 'Banner 4',
//     text: 'صورة شريط التمرير',
//   },
//   {
//     src: '/assets/images/background/banner-2.jpg',
//     alt: 'Banner 2',
//     text: 'صورة شريط التمرير 2',
//   },
//   {
//     src: '/assets/images/background/banner-5.jpg',
//     alt: 'Banner 5',
//     text: '1 صورة شريط التمرير',
//   },
// ];
// useEffect(() => {
//   const interval = setInterval(() => {
//     setCurrentIndex((prevIndex) =>
//       direction ? (prevIndex + 1) % slides.length : (prevIndex - 1 + slides.length) % slides.length,
//     );
//   }, 3000);

//   return () => clearInterval(interval);
// }, [direction, slides.length]);

//   return (
//     <div className="relative mt-10 xl:mt-24 ">
//       {apiData?.map((slide, index) => (
//         <div
//           key={index}
//           className={`relative inset-0 transition-opacity duration-1000 ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`}
//         >
//           <img
//             src={getImageSrc(slide)}
//             alt={'slide.alt'}
//             className="absolute  w-full h-auto object-cover" // Use object-cover to fill the container
//           />

//           <div className="absolute inset-0 flex flex-col justify-center items-center">
//             {/* Overlay */}
//             <div
//               className={`absolute inset-0  ${
//                 (pathname === '/CategoryList' || pathname === '/GeneralDonation' || pathname === '/add-cart') &&
//                 'bg-customgreen opacity-30'
//               }`}
//             ></div>

//             {/* Title based on pathname */}
//             <h2 className="text-white text-xl sm:text-3xl text-center font-bold z-10 absolute top-[50%] lg:top-[60%] transform -translate-y-1/2">
//               {pathname === '/CategoryList' && t('Category List')}
//               {pathname === '/GeneralDonation' && t('General Donation')}
//               {pathname === '/add-cart' && t('Donation Cart')}
//             </h2>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }

// export default Banner;
import { useState, useEffect } from 'react';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { postAsync } from '../helper/axiosHelper';

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const isActive = useSelector((state) => state.toggle.isActive);
  const { pathname } = useLocation();
  const [apiData, setApiData] = useState([]);
  const [currentDevice, setCurrentDevice] = useState(null); // Track the current device type
  const [pageOptions, setPageOptions] = useState({
    page: 1,
    pageSize: 3,
  });

  const isMobile = () => window.innerWidth < 640;
  const isTablet = () => window.innerWidth >= 640 && window.innerWidth < 1024;
  const isDesktop = () => window.innerWidth >= 1024;

  // API call functions
  const mobile = async () => {
    await postAsync(
      `CMS_Slider/GetActiveSliderMobile?page=${pageOptions.page}&pageSize=${pageOptions.pageSize}`,
      {},
    ).then((response) => {
      setApiData(response.data);
    });
  };

  const tab = async () => {
    await postAsync(
      `CMS_Slider/GetActiveSliderTablet?page=${pageOptions.page}&pageSize=${pageOptions.pageSize}`,
      {},
    ).then((response) => {
      setApiData(response.data);
    });
  };

  const desk = async () => {
    await postAsync(
      `CMS_Slider/GetActiveSliderDesktop?page=${pageOptions.page}&pageSize=${pageOptions.pageSize}`,
      {},
    ).then((response) => {
      setApiData(response.data);
    });
  };

  // Check the screen size and run the appropriate function if the device type has changed
  const checkDeviceType = () => {
    let newDevice = null;
    if (isMobile()) {
      newDevice = 'mobile';
    } else if (isTablet()) {
      newDevice = 'tablet';
    } else if (isDesktop()) {
      newDevice = 'desktop';
    }

    // Only call the API if the device type has changed
    if (newDevice && newDevice !== currentDevice) {
      setCurrentDevice(newDevice);
      if (newDevice === 'mobile') {
        mobile();
      } else if (newDevice === 'tablet') {
        tab();
      } else if (newDevice === 'desktop') {
        desk();
      }
    }
  };

  // to check size of window
  useEffect(() => {
    checkDeviceType(); // Run on component mount

    // Set up an event listener for window resizing
    window.addEventListener('resize', checkDeviceType);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener('resize', checkDeviceType);
    };
  }, [currentDevice]);

  useEffect(() => {
    if (apiData.length > 2) {
      const slideInterval = setInterval(() => {
        setCurrentSlide((prevSlide) => (prevSlide === apiData.length - 1 ? 0 : prevSlide + 1));
      }, 4000);

      return () => clearInterval(slideInterval);
    }
  }, [apiData.length]);

  return (
    <>
      {apiData && apiData.length > 0 ? (
        <>
          <div className="relative">
            {/* Slider */}

            <div className="slider mt-10 xl:mt-24 bg-green-50 overflow-hidden relative">
              <img
                src={`data:image/jpeg;base64,${
                  apiData[currentSlide]?.sliderImage1 ||
                  apiData[currentSlide]?.sliderImage2 ||
                  apiData[currentSlide]?.sliderImage3
                }`}
                className={`w-full h-auto object-cover transition-all duration-1000 ease-in-out ${
                  isActive ? 'slider-left' : 'slider-right'
                }`}
                key={currentSlide} // Use `key` to force re-render
              />
            </div>

            {/* Overlay */}
            <div className="absolute inset-0 flex flex-col justify-center items-center">
              {/* Gradient Overlay */}
              <div
                className={`absolute inset-0 ${isActive ? 'bg-gradient-to-l from-customgreen to-transparent' : 'bg-gradient-to-r from-customgreen to-transparent'}  opacity-70`}
              ></div>

              {/* Content */}
              <div
                className={`absolute ${isActive ? 'top-[30%] right-[10%] sm:top-[50%] sm:right-[10%]' : 'top-[30%] left-[10%] sm:top-[50%]  sm:left-[10%]'}`}
              >
                <h2
                  className={`text-white text-xl sm:text-3xl text-center flex font-bold z-10 transform transition-transform duration-500 animate-slide-in`}
                >
                  {pathname === '/' && t(`${apiData[currentSlide]?.sliderName}`)}
                  {pathname === '/CategoryList' && t('Category List')}
                  {(pathname === '/GeneralDonation' || pathname === '/user/GeneralDonation') && t('General Donation')}
                  {pathname === '/add-cart' && t('Donation Cart')}
                </h2>
                <p
                  className={`text-white mt-1  sm:text-lg transform transition-transform duration-500 animate-slide-in`}
                >
                  {pathname === '/' && t(`${apiData[currentSlide]?.sliderNotes}`)}
                  {pathname === '/CategoryList' && t(`${apiData[currentSlide]?.sliderNotes}`)}
                  {(pathname === '/GeneralDonation' || pathname === '/user/GeneralDonation') &&
                    t(`${apiData[currentSlide]?.sliderNotes}`)}
                  {pathname === '/add-cart' && t(`${apiData[currentSlide]?.sliderNotes}`)}
                </p>
                <a
                  href={apiData[currentSlide]?.sliderLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block hover:scale-105 transition-transform duration-300 "
                >
                  <button
                    className={`font-medium  text-lg px-2 py-1 flex justify-center items-center sm:px-4 sm:py-2 mt-2 rounded-full bg-gradient-to-l from-customorange to-customgreen text-white text-md sm:text-xl text-center sm:font-bold
            hover:bg-gradient-to-l hover:from-customgreen hover:to-customorange transition-all duration-300 animate-slide-in`}
                  >
                    {` ${t('More Details')}...`}
                  </button>
                </a>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="mt-10 xl:mt-24">
          <div
            role="status"
            className="space-y-8 animate-pulse md:space-y-0 md:space-x-8 rtl:space-x-reverse md:flex md:items-center"
          >
            <div className="w-full flex justify-center">
              <div className="flex items-center justify-center w-full h-[40vh] lg:h-[60vh] bg-gray-300 rounded dark:bg-gray-300">
                <svg
                  className="w-20 h-20 md:w-32 md:h-32 lg:w-56 lg:h-56 text-gray-200 dark:text-gray-500"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 18"
                >
                  <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                </svg>
              </div>
            </div>
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
    </>
  );
};

export default Slider;
